var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"p-commentField",attrs:{"elevation":"0","max-width":"380"}},_vm._l((_vm.existItems),function(item,index){return _c('comment-list',{key:item.uuid,attrs:{"item":item,"index":index}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }